import request from '@/utils/request'
import URL from './urlTranslator'

export function getCountryList(params) {
  return request({
    url: URL.country.countryInfo,
    method: 'get',
    params
  })
}

export function getPagingCountryList(params) {
  return request({
    url: `${URL.country.countryInfo}/paging`,
    method: 'get',
    params
  })
}

export function getCountryByCode(code) {
  return request({
    url: URL.country.countryByCode,
    method: 'get',
    params: { code }
  })
}

export function batchDelCountry(uuidList) {
  const data = [...uuidList]
  return request({
    url: `${URL.country.countryInfo}`,
    method: 'delete',
    data
  })
}

export function getCountryById(id) {
  return request({
    url: `${URL.country.countryInfo}/${id}`,
    method: 'get'
  })
}

export function saveCountry(data, id) {
  return request({
    url: `${URL.country.countryInfo}`,
    method: id ? 'put' : 'post',
    data
  })
}

export function delCountry(id) {
  return request({
    url: `${URL.country.countryInfo}/${id}`,
    method: 'delete'
  })
}
export function switchCountryStatus(id, status) {
  return request({
    url: ''
  })
}

